import { Helmet } from "react-helmet-async";

const SITE_URL = "https://mancuniarebel.com";
const SITE_NAME = "Mancunia Rebél";
const DEFAULT_DESCRIPTION = "Empowering Creatives. Celebrating media, independent music, fashion, the arts, film, photography & independent creatives. Est. 2014, Manchester UK.";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_rebel-mag/artifacts/b4hgwle1_1000032534-removebg-preview.png";

const SEO = ({ 
  title, 
  description, 
  image, 
  url, 
  type = "website",
  article = null,
  keywords = []
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Empowering Creatives`;
  const desc = description || DEFAULT_DESCRIPTION;
  const img = image || DEFAULT_IMAGE;
  const canonical = url ? `${SITE_URL}${url}` : SITE_URL;
  const defaultKeywords = ["Mancunia Rebél", "Manchester", "music", "fashion", "arts", "film", "photography", "independent creatives", "Preachaman TV"];
  const allKeywords = [...new Set([...keywords, ...defaultKeywords])].join(", ");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={allKeywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Article specific */}
      {article && (
        <>
          <meta property="article:published_time" content={article.published_at} />
          <meta property="article:author" content={article.authorName} />
          <meta property="article:section" content={article.category} />
          {article.tags?.map(tag => (
            <meta key={tag} property="article:tag" content={tag} />
          ))}
        </>
      )}

      {/* JSON-LD Structured Data */}
      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": title,
            "description": desc,
            "image": img,
            "datePublished": article.published_at,
            "dateModified": article.published_at,
            "author": {
              "@type": "Person",
              "name": article.authorName
            },
            "publisher": {
              "@type": "Organization",
              "name": SITE_NAME,
              "url": SITE_URL
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": canonical
            },
            "keywords": article.tags?.join(", ")
          })}
        </script>
      )}

      {/* Site-level JSON-LD (non-article pages) */}
      {!article && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": SITE_NAME,
            "url": SITE_URL,
            "description": desc,
            "publisher": {
              "@type": "Organization",
              "name": SITE_NAME
            }
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
